import { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import Preloader from "../../shared/PreLoaders";
import { Authorization } from "../../Context/Authorization";
import { AuthContext } from "../../Context/AuthContext";

const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };
const fieldWrap = { marginBottom: 16 };
const errStyle = { fontSize: 11, color: "#E53E3E", marginTop: 4 };

const AddDocument = () => {
  const initialStage = {
    vfcName: "",
    rangeId: "",
    documentName: "",
    documentType: "",
    documentNo: "",
    date: "",
    details: "",
    uploadDocument: "",
  };

  const { selectedJfmcType } = useContext(AuthContext);
  const [errors, setErrors] = useState({});
  const [rangeOptions, setRangeOptions] = useState([]);
  const [vfcData, setVfcData] = useState([]);
  const [formData, setFormData] = useState(initialStage);
  const [loading, setLoading] = useState(false);
  const Api = process.env.REACT_APP_API;

  const validateForm = (formData) => {
    const newErrors = {};
    if (!formData.vfcName) newErrors.vfcName = "VFC name is required";
    if (!formData.rangeId) newErrors.rangeId = "Please select Range Id";
    if (!formData.documentName) newErrors.documentName = "Please enter Document Name";
    if (!formData.documentType) newErrors.documentType = "Please select Document Type";
    if (!formData.documentNo) newErrors.documentNo = "Please enter Document No";
    if (!formData.date) newErrors.date = "Please enter Date";
    if (!formData.details) newErrors.details = "Please enter Details";
    if (!formData.uploadDocument) newErrors.uploadDocument = "Please enter Upload Document";
    return newErrors;
  };

  useEffect(() => {
    if (!selectedJfmcType) return;
    const fetchRange = async () => {
      setLoading(true);
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/ranges`, Config);
        setRangeOptions(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error("Error fetching ranges", err);
      } finally {
        setLoading(false);
      }
    };
    fetchRange();
  }, [Api, selectedJfmcType]);

  const fetchVfcByRange = async (rangeId) => {
    setLoading(true);
    try {
      const Config = Authorization();
      const response = await axios.post(
        `${Api}/api/vfcs/vfcs-by-range`,
        { rangeId, jfmcTypeId: selectedJfmcType?._id },
        Config
      );
      const data = response.data.vfcs;
      if (Array.isArray(data)) {
        setVfcData(data);
      } else {
        console.error("API did not return an array", data);
      }
    } catch (err) {
      console.error("Error fetching VFCs by range", err);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { id, value, files } = e.target;
    if (id === "rangeId") fetchVfcByRange(value);
    setFormData((prev) => ({ ...prev, [id]: files ? files[0] : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all Details");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("vfcId", formData.vfcName);
    formDataToSend.append("rangeId", formData.rangeId);
    formDataToSend.append("documentName", formData.documentName);
    formDataToSend.append("documentType", formData.documentType);
    formDataToSend.append("documentNo", formData.documentNo);
    formDataToSend.append("date", formData.date);
    formDataToSend.append("details", formData.details);
    if (formData.uploadDocument) {
      formDataToSend.append("uploadDocument", formData.uploadDocument);
    }

    try {
      const Config = Authorization();
      const response = await fetch(`${Api}/api/documents/documents`, {
        method: "POST",
        headers: { ...Config.headers },
        body: formDataToSend,
      });
      if (response.ok) {
        toast.success("Added Successfully");
        setFormData(initialStage);
        setErrors({});
      } else {
        toast.error("Error submitting form");
      }
    } catch (error) {
      toast.error("Error submitting form");
    }
  };

  const focusStyle = (e) => (e.target.style.borderColor = "#4CAF50");
  const blurStyle = (e) => (e.target.style.borderColor = "#E2E8F0");

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Add Document</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>Document</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Add New Document</span>
        </div>
      </div>

      {!selectedJfmcType ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #FED7D7", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ width: 60, height: 60, background: "#FFF5F5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
            <i className="mdi mdi-tag-outline" style={{ fontSize: 28, color: "#E53E3E" }} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>JFMC Type not selected</div>
          <div style={{ fontSize: 12, color: "#A0AEC0" }}>Use the <strong>JFMC Type</strong> selector in the top navigation bar</div>
        </div>
      ) : (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", overflow: "hidden" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "14px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
            <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
              <i className="mdi mdi-file-plus" />
            </span>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>New Document Form</span>
          </div>

          <div style={{ padding: "24px 28px" }}>
            <form onSubmit={handleSubmit}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                <div style={fieldWrap}>
                  <label htmlFor="rangeId" style={labelStyle}>Range</label>
                  <select id="rangeId" value={formData.rangeId} onChange={handleChange}
                    style={{ ...inputStyle, borderColor: errors.rangeId ? "#E53E3E" : "#E2E8F0" }}
                    onFocus={focusStyle} onBlur={blurStyle}>
                    <option value="">Select Range</option>
                    {rangeOptions.map((range) => (
                      <option key={range._id} value={range._id}>{range.rangeName}</option>
                    ))}
                  </select>
                  {errors.rangeId && <div style={errStyle}>{errors.rangeId}</div>}
                </div>

                <div style={fieldWrap}>
                  <label htmlFor="vfcName" style={labelStyle}>VFC Name</label>
                  <select id="vfcName" value={formData.vfcName} onChange={handleChange}
                    style={{ ...inputStyle, borderColor: errors.vfcName ? "#E53E3E" : "#E2E8F0" }}
                    onFocus={focusStyle} onBlur={blurStyle}>
                    <option value="">Select VFC</option>
                    {vfcData.map((vfc) => (
                      <option key={vfc._id} value={vfc._id}>{vfc.vfcName}</option>
                    ))}
                  </select>
                  {errors.vfcName && <div style={errStyle}>{errors.vfcName}</div>}
                </div>

                <div style={fieldWrap}>
                  <label htmlFor="documentName" style={labelStyle}>Document Name</label>
                  <input id="documentName" type="text" value={formData.documentName} onChange={handleChange}
                    style={{ ...inputStyle, borderColor: errors.documentName ? "#E53E3E" : "#E2E8F0" }}
                    onFocus={focusStyle} onBlur={blurStyle} />
                  {errors.documentName && <div style={errStyle}>{errors.documentName}</div>}
                </div>

                <div style={fieldWrap}>
                  <label htmlFor="documentType" style={labelStyle}>Document Type</label>
                  <select id="documentType" value={formData.documentType} onChange={handleChange}
                    style={{ ...inputStyle, borderColor: errors.documentType ? "#E53E3E" : "#E2E8F0" }}
                    onFocus={focusStyle} onBlur={blurStyle}>
                    <option value="">Select Document Type</option>
                    <option value="renewal">VFC Renewal Certificate</option>
                    <option value="bylaw">VFC Bye Law</option>
                    <option value="audit">VFC Audit Reports</option>
                    <option value="success">Success Story Reports</option>
                  </select>
                  {errors.documentType && <div style={errStyle}>{errors.documentType}</div>}
                </div>

                <div style={fieldWrap}>
                  <label htmlFor="documentNo" style={labelStyle}>Document No</label>
                  <input id="documentNo" type="text" value={formData.documentNo} onChange={handleChange}
                    style={{ ...inputStyle, borderColor: errors.documentNo ? "#E53E3E" : "#E2E8F0" }}
                    onFocus={focusStyle} onBlur={blurStyle} />
                  {errors.documentNo && <div style={errStyle}>{errors.documentNo}</div>}
                </div>

                <div style={fieldWrap}>
                  <label htmlFor="date" style={labelStyle}>Date</label>
                  <input id="date" type="date" value={formData.date} onChange={handleChange}
                    style={{ ...inputStyle, borderColor: errors.date ? "#E53E3E" : "#E2E8F0" }}
                    onFocus={focusStyle} onBlur={blurStyle} />
                  {errors.date && <div style={errStyle}>{errors.date}</div>}
                </div>

                <div style={fieldWrap}>
                  <label htmlFor="details" style={labelStyle}>Details</label>
                  <input id="details" type="text" value={formData.details} onChange={handleChange}
                    style={{ ...inputStyle, borderColor: errors.details ? "#E53E3E" : "#E2E8F0" }}
                    onFocus={focusStyle} onBlur={blurStyle} />
                  {errors.details && <div style={errStyle}>{errors.details}</div>}
                </div>

                <div style={fieldWrap}>
                  <label htmlFor="uploadDocument" style={labelStyle}>Upload Document</label>
                  <input id="uploadDocument" type="file" onChange={handleChange}
                    style={{ ...inputStyle, borderColor: errors.uploadDocument ? "#E53E3E" : "#E2E8F0", cursor: "pointer" }}
                    onFocus={focusStyle} onBlur={blurStyle} />
                  {errors.uploadDocument && <div style={errStyle}>{errors.uploadDocument}</div>}
                </div>
              </div>

              <div style={{ marginTop: 8 }}>
                <button type="submit"
                  style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "10px 24px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: "pointer", boxShadow: "0 3px 10px rgba(46,125,50,0.3)" }}>
                  <i className="mdi mdi-check" /> Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddDocument;
